// Biztonságos JSON-LD sorosítás (M4 – AppSec hardening).
//
// A `JSON.stringify` NEM escape-eli a `<`, `>`, `&` karaktereket, ezért ha
// dinamikus adat (pl. office API-ból jövő készülék-név) `</script>`-et tartalmaz,
// kitörhet a `<script type="application/ld+json">` blokkból → stored XSS.
// Ez a helper a három kritikus karaktert unicode-escape-eli; a JSON-LD
// fogyasztók (Google stb.) a `<`-t szabályosan visszaolvassák, a HTML
// parser viszont már nem látja `</script>`-nek.
export const safeJsonLd = (data) =>
  JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');

export default safeJsonLd;
